/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosPoolRequest = {
    sortField?: AptosPoolRequest.sortField;
    sortDirection?: AptosPoolRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace AptosPoolRequest {

    export enum sortField {
        TVL = 'TVL',
        APY = 'APY',
        APY_BASE = 'APY_BASE',
        APY_REWARD = 'APY_REWARD',
        APY_AVG_30D = 'APY_AVG_30D',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

